import React from 'react';
import './TopBar.css';
import { FaPhoneAlt, FaEnvelope, FaFacebookF, FaWhatsapp, FaInstagram, FaYoutube } from 'react-icons/fa';

const TopBar = () => {
  return (
    <div className="topbar">
      <div className="topbar-left">
        <span><FaPhoneAlt /> +91 7000434300</span>
        <span><FaEnvelope /> help@sahajpublicschool.org</span>
      </div>
      <div className="topbar-right">
        <a href="https://www.facebook.com/sahajpublicschool" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
        <a href="https://wa.me/7000434300" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>
        <a href="https://www.instagram.com/sahajpublicschool" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
        <a href="http://www.youtube.com/@sahajpublicschool" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
      </div>
    </div>
  );
};

export default TopBar;
